import State from './State';
import StateContext, { StateConsumer, StateProvider } from './StateContext';

export { StateContext, StateConsumer, StateProvider };

export default State;
